import { render, staticRenderFns } from "./StatisticList.vue?vue&type=template&id=5ac150e3&scoped=true"
import script from "./StatisticList.vue?vue&type=script&lang=js"
export * from "./StatisticList.vue?vue&type=script&lang=js"
import style0 from "./StatisticList.vue?vue&type=style&index=0&id=5ac150e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac150e3",
  null
  
)

export default component.exports